<ng-container
  *ngIf="{ activeOnboardingGroup: activeOnboardingGroup$ | async } as $"
></ng-container>
<router-outlet></router-outlet>
